'use strict';

// Thin fetch wrappers. `credentials: 'include'` carries the httpOnly session cookie.
// In the browser, paths are same-origin (BASE = ''). In Node (tests/headless flows),
// set globalThis.__W3K_API_BASE to an absolute origin so relative paths resolve.
const BASE = (typeof window !== 'undefined') ? '' : (globalThis.__W3K_API_BASE || '');

async function req(method, path, body) {
  const opts = { method, credentials: 'include', headers: {} };
  if (body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const r = await fetch(BASE + path, opts);
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
  return data;
}

module.exports = {
  register: (registration, email) => req('POST', '/auth/register', { email, ...registration }),
  params: (email) => req('POST', '/auth/params', { email }),
  login: (email, authVerifier) => req('POST', '/auth/login', { email, authVerifier }),
  logout: () => req('POST', '/auth/logout', {}),
  session: () => req('GET', '/auth/session'),
  getVault: () => req('GET', '/vault'),
  putVault: (vaultBlob) => req('PUT', '/vault', { vaultBlob }),
  republishDid: (handle, payload) => req('POST', '/u/' + handle + '/republish', payload),
  registerAttestation: (rec) => req('POST', '/attestations', rec),
  checkAttestation: (hash) => req('GET', '/attestations/' + hash).then(() => true).catch(() => false),
  revoke: (rec) => req('POST', '/revocations', rec),
  checkRevocation: (hash) => req('GET', '/revocations/' + hash).then((d) => !!d.revoked).catch(() => false),
  // Managed 2-of-3 recovery
  recoveryConfig: () => req('GET', '/recovery/config'),
  recoveryChallenge: (email) => req('POST', '/recovery/challenge', { email }),
  recoveryCompanySlice: (email, nonce) => req('POST', '/recovery/company-slice', { email, nonce }),
  recoveryCancel: (email, cancelToken) => req('POST', '/recovery/company-slice/cancel', { email, cancelToken }),
  recoveryReset: (payload) => req('POST', '/recovery/reset', payload),
  // Issuance inbox
  inbox: () => req('GET', '/inbox'),
  inboxClaim: (id) => req('POST', '/inbox/' + id + '/claim', {}),
  inboxReject: (id) => req('POST', '/inbox/' + id + '/reject', {}),
  // Collection (1Sat Ordinals, read-only)
  collection: (address) => req('GET', '/collection/' + address),
  // Wallet (Finance account — BSV chain state via proxy; keys stay in the browser)
  walletBalance: (address) => req('GET', '/wallet/balance/' + address),
  walletHistory: (address) => req('GET', '/wallet/history/' + address),
  walletUtxos: (address) => req('GET', '/wallet/utxos/' + address),
  walletBroadcast: (txhex) => req('POST', '/wallet/broadcast', { txhex }),
  setReceiveInfo: (financeAddress, financePubKey) => req('PUT', '/wallet/receive-info', { financeAddress, financePubKey }),
  // Friendly usernames (username@web3keys.com paymail)
  usernameAvailable: (u) => req('GET', '/username/available?u=' + encodeURIComponent(u)),
  myUsername: () => req('GET', '/username/me'),
  claimUsername: (username) => req('POST', '/username/claim', { username }),
  paymailResolve: (paymail, amount) => req('GET', '/paymail/resolve?paymail=' + encodeURIComponent(paymail) + '&amount=' + (amount || 0)),
  // Document signing
  signDocument: (vc) => req('POST', '/documents', { vc }),
  documents: () => req('GET', '/documents'),
  anchorConfig: () => req('GET', '/anchor/config'),
  // BAP on-chain identity
  publishBap: (fields, identityKey) => req('POST', '/bap/publish', { fields, identityKey }),
  bapStatus: () => req('GET', '/bap'),
  // Selective disclosure (share cards)
  createShareCard: (vc) => req('POST', '/disclosures', { vc }),
  shareCards: () => req('GET', '/disclosures'),
  revokeShareCard: (cardId, signature) => req('POST', '/disclosures/' + cardId + '/revoke', { signature }),
  // Permissions (connected apps)
  permissions: () => req('GET', '/permissions'),
  grantPermission: (clientId, scope) => req('POST', '/permissions/grant', { clientId, scope }),
  revokePermission: (clientId) => req('POST', '/permissions/' + clientId + '/revoke', {}),
};
